import { render } from "./Main.vue?vue&type=template&id=0c221c97"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
script.render = render

export default script